// Recurrence interval/frequency controls for TaskDateTimeFields.
import { Box } from '@mui/material';
import { translate as t } from '@/i18n/useT';
import {
  formGroupInlineSx,
  recurrenceOptionsSx,
} from '@/features/tasks/components/forms/taskFormStyles';

export function TaskDateTimeRecurrenceOptions({
  isRecurrenceEnabled,
  recurrenceInterval,
  setRecurrenceInterval,
  recurrenceFrequency,
  setRecurrenceFrequency,
}) {
  if (!isRecurrenceEnabled) return null;
  return (
    <Box sx={recurrenceOptionsSx}>
      <Box sx={formGroupInlineSx}>
        <Box component="label" htmlFor="recurrence-interval">
          {t('taskdatetimefields.repeatEvery', 'Repeat every')}
        </Box>
        <Box
          component="input"
          type="number"
          id="recurrence-interval"
          name="recurrence_interval"
          value={recurrenceInterval}
          onChange={(e) => setRecurrenceInterval(parseInt(e.target.value, 10))}
          min="1"
        />
      </Box>
      <Box sx={formGroupInlineSx}>
        <Box component="label" htmlFor="recurrence-frequency">
          {t('taskdatetimefields.period', 'Period')}
        </Box>
        <Box
          component="select"
          id="recurrence-frequency"
          name="recurrence_frequency"
          value={recurrenceFrequency}
          onChange={(e) => setRecurrenceFrequency(e.target.value)}
        >
          <option value="days">{t('taskdatetimefields.days', 'Days')}</option>
          <option value="weeks">
            {t('taskdatetimefields.weeks', 'Weeks')}
          </option>
          <option value="months">
            {t('taskdatetimefields.months', 'Months')}
          </option>
        </Box>
      </Box>
    </Box>
  );
}
